import {createSelector} from 'reselect'

export const getLoading = createSelector(
  state => Boolean(state && state.vehicleParts && state.vehicleParts.filter && state.vehicleParts.filter.isFilteredFieldsLoading),
  isLoading => isLoading
)
